export enum MarketingTrackEventName {
  EmailOptInToggled = 'Marketing Email Opt-In Toggled',
  SmsOptInToggled = 'Marketing SMS Opt-In Toggled',
}
